import React from 'react';
import styles from "./styles.module.scss";
import MonthlyValuesLineChart from "../../components/MonthlyValuesLineChart/MonthlyValuesLineChart";
import {useQuery} from "react-query";
import {getDataDashboard} from "../../services/services";
import {IDashboard} from "../../ts/interfaces/interface";

const Dashboard: React.FC = () => {
    document.title = 'Admin - Ellon Sports';

    const {data} = useQuery<IDashboard>(['dashboard'], () => getDataDashboard())

    return (
        <div className={styles.container}>
            <h1>Início</h1>
            {data && data.data &&
                <div style={{width: "70%", margin: "0 auto"}}>
                    <div>
                        <MonthlyValuesLineChart data={data.data.order_prices} total={data.data.final_price}/>
                    </div>
                    <div className={styles.cards}>
                        <div className={styles.card}>
                            <p>Total Líquido Recebido</p>
                            <span>{data.data.liquid_total}</span>
                        </div>
                        <div className={styles.card}>
                            <p>Frete total</p>
                            <span>{data.data.total_freight}</span>
                        </div>
                        <div className={styles.card}>
                            <p>Custo Total</p>
                            <span>{data.data.cost_total}</span>
                        </div>
                        <div className={styles.card}>
                            <p>Total de pedidos</p>
                            <span>{data.data.total}</span>
                        </div>
                    </div>
                    <div className={styles.cards}>
                    </div>
                </div>
            }
        </div>
    );
};

export default Dashboard;
